import {
  getSharedAssetContainerStyle,
  getSharedMultiSelectingCellStyles,
} from './shared-cell-style';

export const getVideoAssetsGridCellStyle = (components, { palette = {} } = {}) => ({
  VideoAssetsGridCellContainer: {
    ...getSharedAssetContainerStyle(components, { palette }),
  },

  // only show checkbox on overlay if it is NOT in multi-selecting mode
  ...getSharedMultiSelectingCellStyles(components, { palette }),
});
